import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';
import { AddServiceTopackageWizardEffects } from './effects';
import * as fromAddServiceTopackageWizard from './reducer';

export function provideAddServiceTopackageWizardStoreV26(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideState(fromAddServiceTopackageWizard.addServiceTopackageWizardFeatureKey, fromAddServiceTopackageWizard.reducer),
    provideEffects(AddServiceTopackageWizardEffects),
  ]);
}
